module.exports = __webpack_public_path__ + "static/media/beta-alanine.4fbf8583.png";